import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function CustomLinkImportRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.CustomLinkImport', {
		url: '/admin/custom_links',
		controllerAs: 'vm',
		controller: CustomLinkImportCtrl,
		templateUrl: '/ng/hub/CustomLink/Import/CustomLinkImportCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/CustomLink/Import/CustomLinkImportCtrl.css'),
			$title: () => 'Custom Links',
			groups: ApiResourcify.endpoint('/custom_links/groups'),
			images: ApiResourcify.endpoint('/custom_links/images'),
		},
	});
}

export class CustomLinkImportCtrl {
	constructor(Api, modal, notifications, groups, images) {
		'ngInject';
		this.Api = Api;
		this.modal = modal;
		this.notifications = notifications;
		this.files = [];
		this.images = [];
		this.groups = groups;
		this.images = images;
		this.details = {
			linkGroup: false,
			linkImage: false,
			text: '',
			readMoreText: '',
			spreadsheetRows: [],
		};
	}

	$onInit() {
		this.allowedExtensions = ['xls', 'xlsx', 'csv', 'ods'];
	}

	handleSpreadsheet(file) {
		this.processing = true;
		this.Api.post('/custom_links/import/spreadsheet', {
			file: file.s3Url,
		}).then(
			data => {
				console.log('Parsed spreadsheet data is', data);
				this.processing = false;
				this.details.spreadsheetRows = data;
			},
			error => {
				console.log('Spreadsheet import error', error);
			}
		);
	}

	save() {
		if (
			!this.linkGroup ||
			!this.linkImage ||
			!this.details.text ||
			!this.details.readMoreText ||
			this.details.spreadsheetRows.length === 0
		) {
			this.modal.alert({ text: 'Please fill in all values' });
			return;
		}
		// get correct group
		this.details.linkGroup = this.linkGroup === 'other' ? this.customLinkGroup : this.linkGroup;
		// get correct image
		this.details.linkImage = this.linkImage === 'other' ? this.customLinkImage : this.linkImage;
		this.Api.post('/custom_links/import', {
			image: this.details.linkImage,
			group: this.details.linkGroup,
			text: this.details.text,
			read_more_text: this.details.readMoreText,
			emails_and_links: this.details.spreadsheetRows,
		}).then(data => {
			this.notifications.showSuccess({
				message: `Links added for ${this.details.spreadsheetRows.length} user(s)`,
			});
		});
	}
}
